/*
 * Ce script JavaScript gère le carrousel d'images de style sur une page web.
 * Il offre les fonctionnalités suivantes :
 * - Navigation par les boutons de navigation précédent et suivant.
 * - Navigation par glissement sur les écrans tactiles.
 * - Mise à jour dynamique des titres et du texte de légende en fonction de l'image affichée.
 */

// Sélection des éléments nécessaires
const styleImagesSlider = document.querySelector(".style-images-slider");
const styleImagesSliderCaption = document.querySelector(".style-images-slider-caption");
const styleImagesSliderItems = document.querySelectorAll(".style-images-article");
const styleImagesSliderPrevButton = document.querySelector(".style-images-slider-prev");
const styleImagesSliderNextButton = document.querySelector(".style-images-slider-next");
const styleImagesSliderPagination = document.getElementById("style-images-slider-pagination");
const styleImagesCaptionTitre = document.querySelector("#style-image-caption-titre");
const styleImagesCaptionTexte = document.querySelector("#style-image-caption-texte");

let currentStyleItem = null;
let currentStyleItemTitre = null;
let currentStyleItemTexte = null;
let styleImagesSliderCurrentIndex = 0;

let xDownStyle = null;
let yDownStyle = null;


if (styleImagesSliderPrevButton && styleImagesSliderNextButton) {
  // Ajout des écouteurs d'événements pour les boutons de navigation
  styleImagesSliderPrevButton.addEventListener("click", () => {
    if (styleImagesSliderCurrentIndex > 0) {
      styleImagesSliderCurrentIndex--;
      updateStyleSlider();
    }
  });

  styleImagesSliderNextButton.addEventListener("click", () => {
    if (styleImagesSliderCurrentIndex < styleImagesSliderItems.length - 1) {
      styleImagesSliderCurrentIndex++;
      updateStyleSlider();
    }
  });

  // Ajout des écouteurs d'événements pour la navigation par glissement
  styleImagesSlider.addEventListener("touchstart", startTouchStyle, {
    passive: true,
  });
  styleImagesSlider.addEventListener("touchmove", moveTouchStyle, {
    passive: true,
  });
  styleImagesSlider.addEventListener("touchend", endTouchStyle, {
    passive: true,
  });
}



// Fonction pour commencer un mouvement tactile
function startTouchStyle(event) {
  xDownStyle = event.touches[0].clientX;
  yDownStyle = event.touches[0].clientY;
}

// Fonction pour déplacer au toucher
function moveTouchStyle(event) {
  if (!xDownStyle || !yDownStyle) {
    return;
  }

  let xUpStyle = event.touches[0].clientX;
  let yUpStyle = event.touches[0].clientY;

  let xDiffStyle = xDownStyle - xUpStyle;
  let yDiffStyle = yDownStyle - yUpStyle;

  // Déterminer la direction du glissement
  if (Math.abs(xDiffStyle) > Math.abs(yDiffStyle)) {
    if (xDiffStyle > 0) {
      // Glissement vers la gauche
      if (styleImagesSliderCurrentIndex < styleImagesSliderItems.length - 1) {
        styleImagesSliderCurrentIndex++;
        updateStyleSlider();
      }
    } else {
      // Glissement vers la droite
      if (styleImagesSliderCurrentIndex > 0) {
        styleImagesSliderCurrentIndex--;
        updateStyleSlider();
      }
    }
  } else {
    if (yDiffStyle > 0) {
      // Glissement vers le haut
    } else {
      // Glissement vers le bas
    }
  }

  // Réinitialiser les coordonnées du toucher
  xDownStyle = null;
  yDownStyle = null;
}

// Fonction pour terminer un mouvement tactile
function endTouchStyle() {
  xDownStyle = null;
  yDownStyle = null;
}

// Fonction pour mettre à jour le slider lors de la navigation
function updateStyleSlider() {
  styleImagesSlider.style.transform = `translateX(-${styleImagesSliderCurrentIndex * (styleImagesSlider.offsetWidth / styleImagesSliderItems.length)}px)`;
  currentStyleItem = styleImagesSliderItems[styleImagesSliderCurrentIndex];
  currentStyleItemTitre = document.querySelector(`#style-image-detail-titre-${styleImagesSliderCurrentIndex + 1}`);
  currentStyleItemTexte = document.querySelector(`#style-image-detail-texte-${styleImagesSliderCurrentIndex + 1}`);
  setStyleSlideUp(
    currentStyleItemTitre.innerHTML,
    currentStyleItemTexte.innerHTML
  );

  if (styleImagesSliderCurrentIndex == 0) {
    styleImagesSliderPrevButton.style.cursor = "not-allowed";
    styleImagesSliderPrevButton.style.opacity = ".6";
    styleImagesSliderNextButton.style.cursor = "pointer";
    styleImagesSliderNextButton.style.opacity = "1";
  } else {
    if (styleImagesSliderCurrentIndex == styleImagesSliderItems.length - 1) {
      styleImagesSliderPrevButton.style.cursor = "pointer";
      styleImagesSliderPrevButton.style.opacity = "1";
      styleImagesSliderNextButton.style.cursor = "not-allowed";
      styleImagesSliderNextButton.style.opacity = ".6";
    } else {
      styleImagesSliderPrevButton.style.cursor = "pointer";
      styleImagesSliderPrevButton.style.opacity = "1";
      styleImagesSliderNextButton.style.cursor = "pointer";
      styleImagesSliderNextButton.style.opacity = "1";
    }
  }
  
  styleImagesSliderPagination.innerText = `${styleImagesSliderCurrentIndex + 1}/${styleImagesSliderItems.length}`;

}

// Fonctions pour la mise à jour des légendes
function setStyleSlideUp(newTitre, newTexte) {
  let height = 0;
  // styleImagesSliderCaption.style.maxHeight = `calc(44px + 7rem)`;
  styleImagesCaptionTitre.classList.replace("slide-up", "slide-up-out");
  setTimeout(() => {
    styleImagesCaptionTitre.classList.replace("slide-up-out", "hidden");
  }, 505);
  setTimeout(() => {
    styleImagesCaptionTitre.innerHTML = newTitre;
    styleImagesCaptionTitre.classList.remove("hidden");
    height += styleImagesCaptionTitre.clientHeight;
    styleImagesCaptionTitre.classList.add("slide-up");
  }, 506);

  if (newTexte) {
    setTimeout(() => {
      if (styleImagesCaptionTexte) {
        styleImagesCaptionTexte.classList.replace("slide-up", "slide-up-out");
      }
      setTimeout(() => {
        if (styleImagesCaptionTexte) {
          styleImagesCaptionTexte.classList.replace("slide-up-out", "hidden");
        }
      }, 505);
      setTimeout(() => {
        if (styleImagesCaptionTexte) {
          styleImagesCaptionTexte.innerHTML = newTexte;
          styleImagesCaptionTexte.classList.remove("hidden");
          height += styleImagesCaptionTexte.clientHeight;
          styleImagesCaptionTexte.classList.add("slide-up");
          // styleImagesSliderCaption.style.maxHeight = `calc(${height}px + 7rem)`;
          styleImagesSliderCaption.style.height = `calc(${height}px + ${window.innerWidth >= 992 ? 7 : 3.5}rem)`;
        }
      }, 506);
    }, 100);
  }
}

let defaultHeight = 0
setTimeout(() => {
  defaultHeight += styleImagesCaptionTitre.clientHeight;
  if (styleImagesCaptionTexte) {
    defaultHeight += styleImagesCaptionTexte.clientHeight;
    styleImagesSliderCaption.style.height = `calc(${defaultHeight}px + ${window.innerWidth >= 992 ? 7 : 3.5}rem)`;
  } else {
    styleImagesSliderCaption.style.height = `calc(${defaultHeight}px + ${window.innerWidth >= 992 ? 3.9 : 3.5}rem)`;
  }
  
}, 150);
